export enum ILF_FINANCIAL_STATUS {
  FINANCIALLY_HEALTHY = 'FINANCIALLY_HEALTHY',
  FINANCIALLY_COPING = 'FINANCIALLY_COPING',
  FINANCIALLY_VULNERABLE = 'FINANCIALLY_VULNERABLE',
}

export const ILF_STATUS_IMAGES: { [property in ILF_FINANCIAL_STATUS]: string } = {
  FINANCIALLY_HEALTHY: 'https://leve-assets.s3-sa-east-1.amazonaws.com/images/ilf_saudavel.svg',
  FINANCIALLY_COPING: 'https://leve-assets.s3-sa-east-1.amazonaws.com/images/ilf_sobrevivente.svg',
  FINANCIALLY_VULNERABLE:
    'https://leve-assets.s3-sa-east-1.amazonaws.com/images/ilf_vulneravel.svg',
};

export const ILF_STATUS_COLORS: { [property in ILF_FINANCIAL_STATUS]: string } = {
  FINANCIALLY_HEALTHY: '#408F4D',
  FINANCIALLY_COPING: '#F1B254',
  FINANCIALLY_VULNERABLE: '#B23634',
};

export const ILF_STATUS_NAMES: { [property in ILF_FINANCIAL_STATUS]: string } = {
  FINANCIALLY_HEALTHY: 'Saudável',
  FINANCIALLY_COPING: 'Sobrevivente',
  FINANCIALLY_VULNERABLE: 'Vulnerável',
};
